import React, { useState } from 'react';
import { Clock, LayoutList, KanbanSquare } from 'lucide-react';
import { SavedOutput } from '@/api/types';
import { SavedStats } from './SavedStats';
import { SavedList } from './SavedList';
import { SavedBoard } from './SavedBoard';

interface SavedProps {
  outputs: SavedOutput[];
  onOpen: (output: SavedOutput) => void;
  onDelete: (id: string) => void;
  onUpdateOutput: (id: string, updates: Partial<SavedOutput>) => void;
}

export function Saved({ outputs, onOpen, onDelete, onUpdateOutput }: SavedProps) {
  const [viewMode, setViewMode] = useState<'list' | 'board'>('list');

  if (outputs.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center p-8 bg-slate-100/50 dark:bg-slate-900/50 border border-slate-300 dark:border-slate-800 border-dashed rounded-xl h-full text-center min-h-[300px]">
        <Clock className="w-10 h-10 text-slate-400 dark:text-slate-600 mb-4" />
        <h3 className="text-sm font-medium text-slate-800 dark:text-slate-200 mb-1">No history found</h3>
        <p className="text-xs text-slate-500 max-w-sm">When you run an analysis or generate a cover letter, your saved items will appear here.</p>
      </div>
    );
  }

  return (
    <div className="w-full flex flex-col h-full min-h-0">
      <SavedStats outputs={outputs} />

      <div className="flex items-center justify-between mb-4 shrink-0">
        <h2 className="text-xs font-semibold text-slate-700 dark:text-slate-400 uppercase tracking-wider">Application History</h2>
        
        <div className="flex items-center bg-slate-100 dark:bg-slate-800 p-0.5 rounded-lg border border-slate-200 dark:border-slate-700">
          <button 
            onClick={() => setViewMode('list')}
            className={`p-1.5 rounded-md transition-colors cursor-pointer ${viewMode === 'list' ? 'bg-white dark:bg-slate-600 text-slate-800 dark:text-white dark:shadow-sm' : 'text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200'}`}
            title="List View"
          >
            <LayoutList className="w-4 h-4" />
          </button>
          <button 
            onClick={() => setViewMode('board')}
            className={`p-1.5 rounded-md transition-colors cursor-pointer ${viewMode === 'board' ? 'bg-white dark:bg-slate-600 text-slate-800 dark:text-white dark:shadow-sm' : 'text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200'}`}
            title="Board View"
          >
            <KanbanSquare className="w-4 h-4" />
          </button>
        </div>
      </div>

      {viewMode === 'list' ? (
        <SavedList outputs={outputs} onOpen={onOpen} onDelete={onDelete} onUpdateOutput={onUpdateOutput} />
      ) : (
        <SavedBoard outputs={outputs} onOpen={onOpen} onDelete={onDelete} onUpdateOutput={onUpdateOutput} />
      )}
    </div>
  );
}



